(function($) {
	'use strict';

	var ModuleName = 'tb_htrm';

	var Module = function(elem, options) {
		this.elem = $(elem);
		this.opts = options;
	};

	Module.DEFAULTS = {
		items: 3 //設置默認顯示幾條tr
	};

	//初始化
	Module.prototype.init = function() {
		var $this = this.elem;
		var opts = this.opts;
		var $contentRows = $this.find('tbody tr');
		var $btn = $this.find('.more_btn_up');

		if ($contentRows.length <= opts.items) $btn.addClass('hide');
		// $contentRows.first().children('td:first-child').attr('rowspan', opts.items);
		$contentRows.slice(0, opts.items).removeClass('hide');
		$contentRows.slice(opts.items).addClass('hide');

		$btn.on('click', function() {
			$contentRows.slice(opts.items).toggleClass('hide');
			if (!$(this).hasClass('more_btn_down')) {
				// $contentRows.first().children('td:first-child').attr('rowspan', $contentRows.length);
			} else {
				// $contentRows.first().children('td:first-child').attr('rowspan', opts.items);
			}
			$(this).toggleClass('more_btn_down')
		});
	};

	$.fn[ModuleName] = function(options1, options2, options3) {
		return this.each(function() {
			var $this = $(this);
			var module = $this.data(ModuleName);
			var opts = null;
			if (!!module) {
				if (typeof options1 === 'string' && typeof options2 === 'undefined' && typeof options3 === 'undefined') {
					module[options1]();
				} else if (typeof options1 === 'string' && typeof options2 === 'string' || options2 instanceof Array && typeof options3 === 'boolean') {
					module[options1](options2, options3);
				} else {
					console.log('unsupported options!');
					// throw 'unsupported options!';
				}
			} else {
				opts = $.extend({}, Module.DEFAULTS, (typeof options1 === 'object' && options1));
				module = new Module(this, opts);
				$this.data(ModuleName, module);
				module.init();
			}
		});
	};
})(jQuery);


// WEBPACK FOOTER //
// ./magaele/tb_htrm/module.js